/**
 * Interface used for zeroconf-service
 */
export interface Scanner {
    product: string;
    host: string;
    ip: string;
    serial: string;
    online: boolean;
}

/**
 * Signalling enum providing the values for signalling call.
 * Usage: http://scanner_ip/signal?signal=n
 * n being a sum of the signals one wants to set.
 */
export enum ScannerSignals {
    SCANNER_SIGNAL_STATUS_R = 1,
    SCANNER_SIGNAL_STATUS_G = 2,
    SCANNER_SIGNAL_STATUS_B = 4,
    SCANNER_SIGNAL_LOGO_SMALL = 8,
    SCANNER_SIGNAL_LOGO_MEDIUM = 16,
    SCANNER_SIGNAL_LOGO_LARGE = 32,
    SCANNER_SIGNAL_WIRELESS = 64,
}
